import useQuery from "./useQuery";

const useSnapshotCount = (projectId: string, fromTo: { from: Date; to: Date } | null) =>
  Number(
    useQuery("/projects/:projectId(uuid)/snapshots/count", {
      query: { ...fromTo },
      routeParams: { projectId },
      keepFresh: true,
      keepPreviousData: true,
    }).body,
  );

export default useSnapshotCount;
